import React, { useContext } from 'react';
import { Footer } from '@spotify-internal/s4x-masthead';
import { useRouter } from 'next/router';

import { MarketContext } from 'providers/market';
import { pathWithoutMarket } from 'utils/market/market';

export default function S4AFooter() {
  const { dir, locale, displayNameWithLanguage } = useContext(MarketContext);
  const marketSelectReturnToPath = pathWithoutMarket(useRouter().asPath);

  return (
    <Footer
      language={{
        dir,
        locale,
        market: displayNameWithLanguage,
        useCountryRegionPicker: true,
        marketSelectReturnToPath,
      }}
    />
  );
}
